module.exports = __webpack_public_path__ + "static/media/gr.db77f48c.svg";